import Footer from "../../Footer/Footer";
import Header from "../../Header/Header";

import BlockContent from "../../Block/BlockContent";
import BlockTitle from "../../Block/BlockTitle";
import BlockSubtitle from "../../Block/BlockSubtitle";
import BlockText from "../../Block/BlockText";
import BlockImage from "../../Block/BlockImage";
import BlockButton from "../../Block/BlockButton";
import Block from "../../Block/Block";

function ColorTransfer() {
  return (
    <div>
      <Header/>        

      <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                  height:"200px",
                  width: "100%",
                  backgroundSize: "100% 100%",
                  backgroundPosition: "bottom"}}>
      </div>

      <Block colorTheme="light" gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockTitle>Color Transfer Dataset</BlockTitle>
        </BlockContent>
        <BlockContent>
          <BlockText>In my publication titled "<b>A Software Test Bed for Sharing and Evaluating Color Transfer Algorithms for Images and 3D Objects</b>", I introduced a dataset comprising a diverse collection of images. These images span various scenes, sizes, and color depths, specifically designed for color transfer evaluation.</BlockText>
        </BlockContent>
      </Block>

      <Block gridTemplateColumns="600px 600px">
        <BlockContent>
          <BlockSubtitle>Details</BlockSubtitle>
          <BlockText>
          <ul>
            <li>Representation of five distinct scenes: abstract, city, closeup, interior, and landscape.</li>
            <li>A collection of ten images for each scene, totaling 50 unique images.</li>
            <li>Each of the 50 images is available in four resolutions: 256x256px, 512x512px, 1024x1024px, and 2048x2048px.</li>
            <li>Variation in color depth for all 200 resized images, processed using Photoshop's Indexed Color Mode: 4-color palette, 16-color palette, 256-color palette, and the original color depth.</li>
            <li>A comprehensive compilation of 800 images.</li>
            <li>The initial set of 50 images was sourced from <a href="https://www.flickr.com/">flickr.com</a>, adhering to the <a href="https://creativecommons.org/licenses/by/2.0/deed.en">CC BY 2.0</a>, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC BY-SA 2.0</a>, and <a href="https://creativecommons.org/licenses/by-nc/2.0/deed.en">CC BY-NC 2.0</a> license models. These images were subsequently cropped to a resolution of 2048x2048px.</li>
          </ul>
          </BlockText>
        </BlockContent>
        <BlockContent>
              <BlockImage src={process.env.PUBLIC_URL + '/images/projects/colortransferdataset.webp'}/>
        </BlockContent>
      </Block>

      <Block colorTheme="light" gridTemplateColumns="1200px"> 
        <BlockContent textAlign="center" color="grey" fontStyle="italic">
          <BlockButton onClick={() => window.open('https://huggingface.co/datasets/hpotechius/ColorTransferDataset')}>Download</BlockButton>
        </BlockContent>
      </Block>


      <Footer/>
    </div>
  );
}

export default ColorTransfer;